import { api } from '@/common/api';
import qs from 'qs';

const store = {
    namespaced: true,
    state() {
        return {
            incomes: [],
            pages: {}
        };
    },

    mutations: {
        setIncomes(state, data) {
            state.incomes = data;
        },
        setPages(state, data) {
            state.pages = data;
        },
        clearStore(state) {
            state.incomes = [];
            state.pages = {};
        }
    },
    actions: {
        getPaginatedList({ state, commit }, params) {
            return new Promise((resolve, reject) => {
                api.get('/income/?' + qs.stringify(params)).then(response => {
                    commit('setIncomes', response.data.data);
                    commit('setPages', response.data.meta);
                    resolve(response);
                }).catch(
                    error => {
                        reject(error);
                    });
            });
        },
        async getIncome({ state, commit }, incomeId) {
            try {
                const response = await api.get('/income/' + incomeId);
                return { ...response.data.data };
            } catch (e) {
                throw new Error('Произошла ошибка: ' + e.response.data.error);
            }
        },
        async createIncome({ state, commit }, income) {
            try {
                const response = await api.post('/income/', { ...income });
                return { ...response.data.data };
            } catch (e) {
                let errors = [];
                if (e.response && e.response.status === 422) {
                    errors = e.response.data.errors;
                }
                throw new Error(JSON.stringify(errors));
            }
        },
        async deleteIncome({ state, commit }, incomeId) {
            try {
                await api.delete(`/income/${incomeId}`);
            } catch (e) {
                throw new Error(JSON.stringify(e));
            }
        },
        async updateIncome({ state, commit }, income) {
            try {
                const response = await api.put('/income/' + income.id, { ...income });
                return { ...response.data.data };
            } catch (e) {
                let errors = [];
                if (e.response && e.response.status === 422) {
                    errors = e.response.data.errors;
                }
                throw new Error(JSON.stringify(errors));
            }
        },
        async createDealIncome({ state, commit }, { income }) {
            try {
                await api.post('/income/', income);
            } catch (e) {
                let errors = [];
                if (e.response && e.response.status === 422) {
                    errors = e.response.data.errors;
                }
                throw new Error(JSON.stringify(errors));
            }
        },
        async createDebtsIncomes({ state, commit }, incomes) {
            try {
                return await api.post('/incomes/', incomes);
            } catch (e) {
                let errors = [];
                if (e.response && e.response.status === 422) {
                    errors = e.response.data.errors;
                }
                throw new Error(JSON.stringify(errors));
            }
        }
    }
};

export default store;
